import {
	getLandingMetrics,
	type GetLandingMetricsResponse
} from '@repo/api-portal-sdk/gen'
import type { RouteSdkOptions } from '@repo/ssr'

export type LandingMetrics = GetLandingMetricsResponse['data']

export async function fetchLandingMetrics(sdkOptions: RouteSdkOptions) {
	try {
		const response = await getLandingMetrics(sdkOptions)
		return response.data.data
	} catch (error) {
		if (sdkOptions.signal?.aborted) {
			throw error
		}

		return null
	}
}
